// GlowSkinHouse — Spruce & Bone theme runtime. Original implementation (Cart AJAX, drawers, facets, gallery).
(function(){
  'use strict';

  function qs(s,ctx){ return (ctx||document).querySelector(s); }
  function qsa(s,ctx){ return Array.prototype.slice.call((ctx||document).querySelectorAll(s)); }

  /* ---------- Analytics (no PII) ----------
     Kanonicna definicija zivi v snippets/gsh-analytics.liquid in se nalozi prej.
     Tu je NE prepisujemo — prej smo jo in je isti dogodek dobil dve razlicni
     imeni v dataLayer. Ce snippeta ni (npr. gola stran), skoci vmes enak fallback. */
  function gshTrackFallback(name, detail){
    if (!name) return;
    detail = detail || {};
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'gsh_' + name, gsh_event: name }, detail)); } catch(e){}
    try { if (typeof window.gtag === 'function') window.gtag('event', name, detail); } catch(e){}
    try { document.dispatchEvent(new CustomEvent('gsh:track', { detail: { name: name, data: detail } })); } catch(e){}
  }
  if (typeof window.gshTrack !== 'function') window.gshTrack = gshTrackFallback;
  function gshTrack(name, detail){ try { window.gshTrack(name, detail || {}); } catch(e){} }
  /* Deklarativno merjenje. Payload se sestavi iz treh plasti:
       1. [data-gsh-evt-scope]  — JSON kontekst strani (podeduje ga vsak dogodek v njem)
       2. [data-gsh-evt-data]   — JSON na samem elementu
       3. data-gsh-handle / data-gsh-routine — stari atributa, ohranjena
     Sekcije tako ne potrebujejo lastnega JS. */
  function gshEvtJSON(el, attr){
    var raw = el && el.getAttribute(attr);
    if (!raw) return null;
    try { return JSON.parse(raw); } catch(e){ return null; }
  }
  function gshEvtPayload(t){
    var d = {};
    var scope = t.closest ? t.closest('[data-gsh-evt-scope]') : null;
    var ctx = gshEvtJSON(scope, 'data-gsh-evt-scope');
    if (ctx) { for (var k in ctx) if (Object.prototype.hasOwnProperty.call(ctx, k)) d[k] = ctx[k]; }
    var own = gshEvtJSON(t, 'data-gsh-evt-data');
    if (own) { for (var j in own) if (Object.prototype.hasOwnProperty.call(own, j)) d[j] = own[j]; }
    if (t.getAttribute('data-gsh-handle')) d.handle = t.getAttribute('data-gsh-handle');
    if (t.getAttribute('data-gsh-routine')) d.routine = t.getAttribute('data-gsh-routine');
    return d;
  }
  document.addEventListener('click', function(e){
    var t = e.target.closest ? e.target.closest('[data-gsh-evt]') : null;
    if(!t) return;
    var name = t.getAttribute('data-gsh-evt'); if(!name) return;
    gshTrack(name, gshEvtPayload(t));
  }, true);

  /* [data-gsh-evt-view="ime"] → sprozi enkrat, ko je element res viden. */
  (function(){
    var nodes = qsa('[data-gsh-evt-view]');
    if (!nodes.length) return;
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if (!en.isIntersecting) return;
        var el = en.target;
        if (el.dataset.gshEvtFired === '1') return;
        el.dataset.gshEvtFired = '1';
        io.unobserve(el);
        gshTrack(el.getAttribute('data-gsh-evt-view'), gshEvtPayload(el));
      });
    }, { threshold: 0.35, rootMargin: '0px 0px -10% 0px' });
    nodes.forEach(function(n){ io.observe(n); });
  })();
  document.addEventListener('gsh:drawer:open', function(e){
    try { if (e.detail && e.detail.el === cartDrawer) gshTrack('cart_open', {}); } catch(err){}
  });

  /* ---------- Drawers ---------- */
  function openDrawer(el){ if(!el) return; el.classList.add('is-open'); el.setAttribute('aria-hidden','false'); document.documentElement.style.overflow='hidden'; document.documentElement.classList.add('gsh-drawer-open'); document.dispatchEvent(new CustomEvent('gsh:drawer:open', { detail: { el: el } })); }
  function closeDrawer(el){ if(!el) return; el.classList.remove('is-open'); el.setAttribute('aria-hidden','true'); document.documentElement.style.overflow=''; document.documentElement.classList.remove('gsh-drawer-open'); }

  var cartDrawer = qs('[data-gsh-cart-drawer]');
  var wishDrawer = qs('[data-gsh-wishlist-drawer]');
  var searchOverlay = qs('[data-gsh-search-overlay]');
  var filterDrawer = qs('[data-gsh-filter-drawer]');

  document.addEventListener('click', function(e){
    if (e.target.closest('[data-gsh-cart-open]')) { e.preventDefault(); openDrawer(cartDrawer); renderCart(); }
    if (e.target.closest('[data-gsh-cart-close]')) closeDrawer(cartDrawer);
    if (e.target.closest('[data-gsh-wishlist-open]')) { openDrawer(wishDrawer); renderWishlist(); }
    if (e.target.closest('[data-gsh-wishlist-close]')) closeDrawer(wishDrawer);
    if (e.target.closest('[data-gsh-search-open]')) {
      if (searchOverlay){
        var hdr = qs('.gsh-header__row') || qs('.gsh-header'); var top = hdr ? Math.max(0, Math.round(hdr.getBoundingClientRect().bottom)) : 110;
        searchOverlay.style.setProperty('--gsh-search-top', top + 'px');
        searchOverlay.classList.add('is-open');
        searchOverlay.setAttribute('aria-hidden','false');
      }
      var i=qs('[data-gsh-search-input]'); i && i.focus();
    }
    if (e.target.closest('[data-gsh-search-close]')) { if (searchOverlay){ searchOverlay.classList.remove('is-open'); searchOverlay.setAttribute('aria-hidden','true'); } }
    if (e.target.closest('[data-gsh-filter-open]')) { e.preventDefault(); openDrawer(filterDrawer); }
    if (e.target.closest('[data-gsh-filter-close]')) closeDrawer(filterDrawer);
    var wishToggle = e.target.closest('[data-gsh-wishlist-toggle]');
    if (wishToggle) toggleWishlist(wishToggle.getAttribute('data-gsh-wishlist-toggle'));
    var copyBtn = e.target.closest('[data-gsh-copy]');
    if (copyBtn) {
      var codeEl = copyBtn.parentNode.querySelector('[data-gsh-copy-text]');
      var text = codeEl ? (codeEl.getAttribute('data-gsh-copy-text') || codeEl.textContent) : '';
      if (text && navigator.clipboard) { navigator.clipboard.writeText(text.trim()).then(function(){ var o = copyBtn.textContent; copyBtn.textContent = 'Kopirano ✓'; setTimeout(function(){ copyBtn.textContent = o; }, 1800); }).catch(function(){}); }
    }
    var shareBtn = e.target.closest('[data-gsh-share]');
    if (shareBtn) {
      e.preventDefault();
      var sUrl = shareBtn.getAttribute('data-share-url') || window.location.href;
      var sTitle = shareBtn.getAttribute('data-share-title') || document.title;
      var sText = shareBtn.getAttribute('data-share-text') || '';
      if (navigator.share) { navigator.share({ title: sTitle, text: sText, url: sUrl }).catch(function(){}); }
      else if (navigator.clipboard) { navigator.clipboard.writeText((sText ? sText + ' ' : '') + sUrl).then(function(){ var o2 = shareBtn.innerHTML; shareBtn.textContent = 'Povezava kopirana ✓'; setTimeout(function(){ shareBtn.innerHTML = o2; }, 1800); }).catch(function(){}); }
    }
    var protoAdd = e.target.closest('[data-gsh-proto-add]');
    if (protoAdd) {
      e.preventDefault();
      var ids = (protoAdd.getAttribute('data-variant-ids') || '').split(',').map(function(s){ return s.trim(); }).filter(Boolean);
      if (!ids.length) return;
      var items = ids.map(function(id){ return { id: parseInt(id, 10), quantity: 1 }; });
      protoAdd.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function(r){ return r.json(); })
        .then(function(){ openDrawer(cartDrawer); renderCart(); })
        .catch(function(){})
        .then(function(){ protoAdd.disabled = false; });
    }
  });
  document.addEventListener('keydown', function(e){
    if (e.key !== 'Escape') return;
    closeDrawer(cartDrawer); closeDrawer(wishDrawer); closeDrawer(filterDrawer);
    if (searchOverlay){ searchOverlay.classList.remove('is-open'); searchOverlay.setAttribute('aria-hidden','true'); }
  });

  /* ---------- Cart (Shopify Cart AJAX API) ---------- */
  function money(cents){ return (cents/100).toLocaleString('sl-SI',{minimumFractionDigits:2,maximumFractionDigits:2}) + ' €'; }
  function escapeHtml(s){ return (s||'').replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function thumb(url,size){ if(!url) return ''; if(url.indexOf('//')===0) url='https:'+url; return url.replace(/(\.(?:jpg|jpeg|png|webp|gif))(\?|$)/i, '_'+size+'x'+size+'$1$2'); }

  function cartLineHTML(item){
    var variant = (item.variant_title && item.variant_title !== 'Default Title') ? '<div class="gsh-cart-line__variant">'+escapeHtml(item.variant_title)+'</div>' : '';
    var vendor = item.vendor ? '<div class="gsh-cart-line__vendor">'+escapeHtml(item.vendor)+'</div>' : '';
    var discounted = item.original_line_price > item.final_line_price;
    var was = discounted ? '<span class="gsh-cart-line__was">'+money(item.original_line_price)+'</span>' : '';
    var save = discounted ? '<span class="gsh-cart-line__save">Prihranek '+money(item.original_line_price - item.final_line_price)+'</span>' : '';
    var calc = '<span class="gsh-cart-line__calc">'+item.quantity+' × '+money(item.final_price)+' = <b>'+money(item.final_line_price)+'</b></span>';
    return '<div class="gsh-cart-line" data-key="'+item.key+'">'+
      '<a href="'+item.url+'" class="gsh-cart-line__media"><img src="'+thumb(item.image,120)+'" width="72" height="72" alt="'+escapeHtml(item.product_title)+'" loading="eager"></a>'+
      '<div class="gsh-cart-line__info">'+
        vendor+
        '<a href="'+item.url+'" class="gsh-cart-line__title">'+escapeHtml(item.product_title)+'</a>'+
        variant+
        '<div class="gsh-cart-line__qty">'+
          '<button type="button" data-gsh-qty="-1" data-key="'+item.key+'" aria-label="Zmanjšaj">−</button>'+
          '<span>'+item.quantity+'</span>'+
          '<button type="button" data-gsh-qty="1" data-key="'+item.key+'" aria-label="Povečaj">+</button>'+
        '</div>'+
      '</div>'+
      '<div class="gsh-cart-line__right">'+
        '<div class="gsh-cart-line__pricewrap">'+calc+was+save+'</div>'+
        '<button type="button" class="gsh-cart-line__remove" data-gsh-remove data-key="'+item.key+'">Odstrani</button>'+
      '</div>'+
    '</div>';
  }

  var CUR_STEPS = [
    [/serum|ampul|esenc|essence|drop/, 'Korak 3 · Serum', 'Nanesi po toniku, pred kremo.', 'Dopolnjuje aktivne sestavine v tvoji košarici in cilja globlje.'],
    [/toner|tonik|\bpad\b|blažini|blazini/, 'Korak 2 · Toner', 'Pripravi kožo takoj po čiščenju.', 'Uravnovesi kožo in izboljša vpijanje serumov iz tvoje rutine.'],
    [/krema|cream|moistur|vlažil|vlazil|balm|lotion/, 'Korak 4 · Krema', 'Zaklene vlago kot zadnji korak.', 'Zapre rutino in ohrani vlago sestavin, ki si jih izbrala.'],
    [/čist|cist|cleans|pena|foam|oil clean|balzam/, 'Korak 1 · Čiščenje', 'Prvi korak jutranje in večerne rutine.', 'Čista koža je pogoj, da preostali izdelki delujejo.'],
    [/mask|maska|patch|obliž|obliz|sheet/, 'Ciljana nega', 'Tedenski boost za kožo.', 'Ciljana intenzivna nega ob tvoji dnevni rutini.'],
    [/spf|sun|zaščit|zascit|\buv\b/, 'Korak 5 · Zaščita', 'Zjutraj kot zadnji korak.', 'Ščiti rezultate tvoje nege pred UV poškodbami.']
  ];
  function curStep(p){
    var t = ((p.type||'')+' '+((p.tags||[]).join(' '))+' '+(p.title||'')).toLowerCase();
    for (var i=0;i<CUR_STEPS.length;i++){ if (CUR_STEPS[i][0].test(t)) return {label:CUR_STEPS[i][1], reason:CUR_STEPS[i][2], why:CUR_STEPS[i][3]}; }
    return {label:'Kurirano', reason:'Kurirana dopolnitev tvoje rutine.', why:'Izbrano kot smiselna dopolnitev tvojih izdelkov.'};
  }

  function renderCart(){
    var w0 = qs('[data-gsh-cart-items]');
    if (w0 && !w0.children.length) w0.innerHTML = '<div class="gsh-cart-loading" style="padding:40px;text-align:center;color:var(--muted)">Nalagam košarico …</div>';
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
      var wrap = qs('[data-gsh-cart-items]'); if(!wrap) return;
      var foot = qs('[data-gsh-cart-foot]');
      if (!cart.items.length){
        wrap.innerHTML = '<div class="gsh-cart-empty">'+
          '<div class="gsh-cart-empty__glyph" aria-hidden="true">✦</div>'+
          '<p class="gsh-cart-empty__title">Tvoja košarica je prazna</p>'+
          '<p class="gsh-cart-empty__text">Odkrij kurirane K-beauty izdelke, strokovno izbrane za tvojo rutino.</p>'+
          '<a href="/collections/all" class="gsh-btn gsh-btn--primary" data-gsh-cart-close>Razišči kolekcijo →</a>'+
        '</div>';
        if (foot) foot.hidden = true;
        qsa('[data-gsh-cart-upsell]').forEach(function(u){ u.classList.remove('gsh-has-rec'); });
        CURATED.anchor = null; CURATED.items = null;
      } else {
        wrap.innerHTML = cart.items.map(cartLineHTML).join('');
        if (foot) foot.hidden = false;
        renderUpsell(cart);
      }
      var subtotal = qs('[data-gsh-cart-subtotal]'); if (subtotal) subtotal.textContent = money(cart.total_price);
      qsa('[data-gsh-cart-count]').forEach(function(c){ c.textContent = cart.item_count; if (c.classList.contains('gsh-header__cart-count')) c.hidden = cart.item_count < 1; });
      /* Seštevek PRED popustom + prihranek + skupaj — isti vrstni red kot na blagajni.
         Zadnja vrstica (cart.total_price) je ZE znesek po popustu; ce nad njo pise se
         „Prihranek −X“ brez te vrstice, kupec isti popust odsteje dvakrat. */
      var savings = (cart.items||[]).reduce(function(s,i){ return s + Math.max(0, i.original_line_price - i.final_line_price); }, 0);
      var origrow = qs('[data-gsh-cart-origrow]'), origEl = qs('[data-gsh-cart-original]');
      if (origrow){ if (savings > 0){ origrow.hidden = false; if (origEl) origEl.textContent = money(cart.total_price + savings); } else { origrow.hidden = true; } }
      var saverow = qs('[data-gsh-cart-saverow]'), savEl = qs('[data-gsh-cart-savings]');
      if (saverow){ if (savings > 0){ saverow.hidden = false; if (savEl) savEl.textContent = '– ' + money(savings); } else { saverow.hidden = true; } }
      // shipping row
      var shipEl = qs('[data-gsh-cart-ship]');
      if (shipEl){ var bar = qs('[data-gsh-shipbar]'); var thr = bar ? parseFloat(bar.getAttribute('data-threshold'))*100 : 0; var free = thr && cart.total_price >= thr; shipEl.textContent = free ? 'Brezplačna' : 'obračunana na blagajni'; shipEl.classList.toggle('is-free', !!free); }
      updateShipBar(cart.total_price);
    }).catch(function(){
      var w = qs('[data-gsh-cart-items]');
      if (w) w.innerHTML = '<div class="gsh-cart-empty"><p class="gsh-cart-empty__text">Košarice trenutno ni bilo mogoče naložiti. Osveži stran ali poskusi znova.</p></div>';
    });
  }

  // The curated routine is a FIXED set captured once per anchor product. As the
  // customer adds those items the set shrinks; once complete the card is removed —
  // we never backfill with fresh products to keep pushing more sales.
  var CURATED = { anchor: null, items: null };
  function renderUpsell(cart){
    var hosts = qsa('[data-gsh-cart-upsell]'), rows = qsa('[data-gsh-cart-upsell-row]');
    if (!hosts.length || !cart.items.length) return;
    function hideAll(){ hosts.forEach(function(h){ h.classList.remove('gsh-has-rec'); }); }
    var inCart = cart.items.map(function(i){ return i.product_id; });
    var anchor = cart.items[0].product_id;

    function paint(set){
      var avail = set.filter(function(p){ return inCart.indexOf(p.id) === -1; });
      if (!avail.length){ hideAll(); return; }   // routine complete → remove the card
      var ids = [], total = 0;
      var html = avail.map(function(p){
        var v = (p.variants||[])[0]; if (!v) return '';
        ids.push(v.id); total += (v.price||0);
        var st = curStep(p);
        return '<div class="gsh-cart-cur__item">'+
          '<a href="'+p.url+'" class="gsh-cart-cur__media"><img src="'+thumb(p.featured_image,140)+'" width="58" height="58" alt="'+escapeHtml(p.title)+'" loading="lazy"></a>'+
          '<div class="gsh-cart-cur__info">'+
            (p.vendor ? '<span class="gsh-cart-cur__brand">'+escapeHtml(p.vendor)+'</span>' : '')+
            '<a href="'+p.url+'" class="gsh-cart-cur__name">'+escapeHtml(p.title)+'</a>'+
            '<span class="gsh-cart-cur__reason">'+st.reason+'</span>'+
            '<span class="gsh-cart-cur__meta"><span class="gsh-cart-cur__step">'+st.label+'</span><span class="gsh-cart-cur__price">'+money(v.price)+'</span></span>'+
          '</div>'+
          '<button type="button" class="gsh-cart-cur__add" data-gsh-cart-quickadd data-id="'+v.id+'" aria-label="Dodaj v košarico">+</button>'+
        '</div>';
      }).join('');
      if (ids.length > 1){
        html += '<button type="button" class="gsh-cart-cur__all" data-gsh-bundle-add data-ids="'+ids.join(',')+'">'+
          '<span class="gsh-cart-cur__all-txt">Dodaj vse in dokončaj rutino</span>'+
          '<span class="gsh-cart-cur__all-price">'+money(total)+' →</span>'+
        '</button>';
      }
      rows.forEach(function(rw){ rw.innerHTML = html; });
      hosts.forEach(function(h){ h.classList.add('gsh-has-rec'); });
    }

    // Fixed set: capture ONCE per cart session and reuse for the life of the cart.
    // (Shopify prepends new items, so cart.items[0] is unreliable as a stable anchor —
    // re-fetching on every add would endlessly surface new products. We never do that.)
    if (CURATED.items){ paint(CURATED.items); return; }
    // Prefer merchant-configured COMPLEMENTARY ("goes with") products; fall back to related.
    fetch('/recommendations/products.json?product_id='+anchor+'&limit=10&intent=complementary')
      .then(function(r){ return r.json(); })
      .then(function(d){
        var pool = (d.products||[]);
        if (pool.length) return pool;
        return fetch('/recommendations/products.json?product_id='+anchor+'&limit=10&intent=related').then(function(r){ return r.json(); }).then(function(d2){ return d2.products||[]; });
      })
      .then(function(pool){
        /* Izkljucitev po ID iz samodejnih priporocil (Ana S., 20. 10. 2026): Some By Mi krema za oci, SkinTra Smoother Than Ever, Cos De BAHA S4. Seznam je tudi v sections/gsh-related-products.liquid. */
        var GSH_EXCL = ['15040984580422','15599709225286','15076104503622'];
        var set = pool.filter(function(p){ return p.available && (p.variants||[])[0] && inCart.indexOf(p.id) === -1 && GSH_EXCL.indexOf(String(p.id)) === -1; }).slice(0,3);
        CURATED.anchor = anchor;
        CURATED.items = set;
        if (!set.length){ hideAll(); return; }
        paint(set);
      })
      .catch(function(){ hideAll(); });
  }

  function updateShipBar(totalCents){
    var bar = qs('[data-gsh-shipbar]'); if (!bar) return;
    var threshold = parseFloat(bar.getAttribute('data-threshold')) * 100;
    var fill = qs('[data-gsh-shipbar-fill]'); var label = qs('[data-gsh-shipbar-label]');
    var pct = Math.min(100, Math.round((totalCents/threshold)*100));
    if (fill) fill.style.width = pct + '%';
    var lf = bar.getAttribute('data-label-free'), lr = bar.getAttribute('data-label-remaining');
    if (label) label.textContent = totalCents >= threshold ? (lf || 'Brezplačna dostava odklenjena ✓') : (lr ? lr.replace('[x]', money(threshold - totalCents)) : 'Do brezplačne dostave: ' + money(threshold - totalCents));
  }

  /* ---------- Kolicina v kosarici ----------
     PAST (popravljeno 17. 9. 2026): prej se je trenutna kolicina brala iz DOM-a
     (`line.querySelector('span')`), zahteve pa so sle na /cart/change.js sočasno.
     Dva hitra klika sta zato prebrala ISTO staro stevilko in poslala isto kolicino
     — stevilo se ni premaknilo, Shopify pa je eno od socasnih zahtev zavrnil s 400.
     Za kupca je to izgledalo, kot da gumb + ne dela.

     Zdaj: zeljena kolicina se vodi v `cartWanted` (ne v DOM-u), prikaz se posodobi
     takoj, zahteve pa gredo ena za drugo prek `cartQueue`. Vec klikov med cakanjem
     se zdruzi v eno zahtevo s koncno kolicino. */
  var cartQueue = Promise.resolve();
  var cartWanted = {};

  function cartSetQty(key, qty, line){
    cartWanted[key] = qty;

    var span = line && line.querySelector('.gsh-cart-line__qty span');
    if (span) span.textContent = qty;          // takojsen odziv na klik
    if (qty === 0 && line) line.style.opacity = '.4';

    cartQueue = cartQueue.then(function(){
      if (!(key in cartWanted)) return;        // novejsi klik je to ze pokril
      var want = cartWanted[key];
      delete cartWanted[key];
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: want })
      }).then(function(){
        renderCart();
        document.dispatchEvent(new CustomEvent('gsh:cart:updated'));
      });
    }).catch(function(){
      delete cartWanted[key];
      renderCart();                            // ob napaki nazaj na stanje streznika
    });
  }

  document.addEventListener('click', function(e){
    var qtyBtn = e.target.closest('[data-gsh-qty]');
    if (!qtyBtn) return;
    var delta = parseInt(qtyBtn.getAttribute('data-gsh-qty'), 10);
    var key = qtyBtn.getAttribute('data-key');
    var line = qtyBtn.closest('.gsh-cart-line');
    var span = line && line.querySelector('.gsh-cart-line__qty span');
    var shown = span ? parseInt(span.textContent, 10) : 0;
    var base = (key in cartWanted) ? cartWanted[key] : shown;
    if (!isFinite(base)) return;
    cartSetQty(key, Math.max(0, base + delta), line);
  });

  /* Remove line */
  document.addEventListener('click', function(e){
    var rm = e.target.closest('[data-gsh-remove]');
    if (!rm) return;
    cartSetQty(rm.getAttribute('data-key'), 0, rm.closest('.gsh-cart-line'));
  });

  /* Wishlist: remove line */
  document.addEventListener('click', function(e){
    var rm = e.target.closest('[data-gsh-wish-remove]');
    if (!rm) return;
    toggleWishlist(rm.getAttribute('data-handle'));
  });

  /* Upsell quick-add inside cart drawer */
  document.addEventListener('click', function(e){
    var add = e.target.closest('[data-gsh-cart-quickadd]');
    if (!add || add.disabled) return;
    add.disabled = true; add.textContent = '✓';
    fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ id: parseInt(add.getAttribute('data-id'),10), quantity: 1 }) })
      .then(function(){ renderCart(); document.dispatchEvent(new CustomEvent('gsh:cart:updated')); })
      .catch(function(){ add.disabled = false; add.textContent = '+'; });
  });

  /* Curated upsell — "why we recommend" toggle */
  document.addEventListener('click', function(e){
    var w = e.target.closest('[data-gsh-why]');
    if (!w) return;
    var txt = w.closest('.gsh-cart-cur__body') && w.closest('.gsh-cart-cur__body').querySelector('.gsh-cart-cur__whytext');
    if (txt){ txt.hidden = !txt.hidden; w.classList.toggle('is-open', !txt.hidden); }
  });

  /* Promo code — toggle field + apply via native Shopify discount URL */
  document.addEventListener('click', function(e){
    var t = e.target.closest('[data-gsh-promo-toggle]');
    if (!t) return;
    var f = qs('[data-gsh-promo-form]');
    if (f){ f.hidden = !f.hidden; t.classList.toggle('is-open', !f.hidden); if (!f.hidden){ var inp = f.querySelector('[data-gsh-promo-input]'); inp && inp.focus(); } }
  });
  document.addEventListener('submit', function(e){
    var f = e.target.closest('[data-gsh-promo-form]');
    if (!f) return;
    e.preventDefault();
    var inp = f.querySelector('[data-gsh-promo-input]');
    var code = (inp && inp.value || '').trim();
    if (!code) return;
    /* Koda se uporabi v ozadju (brez osvezitve strani): /discount/ nastavi piskotek, redirect na /cart.js
       vrne kosarico. Samo ce to odpove, kupca vrnemo na isto stran z odprto kosarico (promoReturn). */
    var btn = f.querySelector('button[type="submit"]');
    function fallback(){
      var back = '/';
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('gsh_cart', '1');
        u.searchParams.set('gsh_code', code);
        back = u.pathname + u.search;
      } catch (err) {}
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(back);
    }
    if (btn) btn.disabled = true;
    promoMsg('', true);
    fetch('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart.js'), { credentials: 'same-origin' })
      .then(function(r){ if (!r.ok) throw new Error('discount'); return fetch('/cart.js'); })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var ok = promoApplied(cart, code);
        renderCart();
        promoMsg(ok ? 'Koda ' + code.toUpperCase() + ' je uporabljena.'
                    : 'Koda ' + code.toUpperCase() + ' ni veljavna ali ne velja za izdelke v košarici.', ok);
        if (ok && inp) inp.value = '';
        if (btn) btn.disabled = false;
      })
      .catch(function(){ if (btn) btn.disabled = false; fallback(); });
  });

  /* Bundle / ritual — add all products to cart at once */
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-gsh-bundle-add]');
    if (!b || b.disabled) return;
    var ids = (b.getAttribute('data-ids')||'').split(',').filter(Boolean);
    if (!ids.length) return;
    b.disabled = true; var lbl = b.textContent; b.textContent = 'Dodajam…';
    fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ items: ids.map(function(id){ return { id: parseInt(id,10), quantity: 1 }; }) }) })
      .then(function(){ if (cartDrawer) openDrawer(cartDrawer); renderCart(); b.textContent = 'Dodano ✓'; setTimeout(function(){ b.textContent = lbl; b.disabled = false; }, 1600); })
      .catch(function(){ b.textContent = lbl; b.disabled = false; });
  });

  qsa('product-form, [data-gsh-product-form]').forEach(function(){});

  /* Dodaj v košarico — EN sam poslušalec za vse obrazce /cart/add
     (kartica izdelka, editor picks, produktna stran). Prej sta bila dva in
     vsak klik je dodal izdelek dvakrat. Ne podvajaj tega poslušalca. */
  document.addEventListener('submit', function(e){
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('[type="submit"]') || form.querySelector('button');
    if (btn && (btn.disabled || form.dataset.gshAdding === '1')) return;
    form.dataset.gshAdding = '1';

    /* Kartice imajo besedilno povratno informacijo, produktna stran spinner. */
    var isCard = form.hasAttribute('data-gsh-card-add');
    var label = btn ? btn.textContent : '';
    function restore(){
      form.dataset.gshAdding = '';
      if (!btn) return;
      btn.disabled = false;
      btn.classList.remove('is-loading');
      if (isCard) btn.textContent = label;
    }
    if (btn){
      if (isCard) { btn.disabled = true; btn.textContent = 'Dodajam…'; }
      else btn.classList.add('is-loading');
    }

    fetch('/cart/add.js', { method:'POST', body: new FormData(form) })
      .then(function(r){ return r.json().then(function(data){ return { ok:r.ok, data:data }; }); })
      .then(function(res){
        if (!res.ok) { restore(); showToast(res.data && res.data.description || 'Izdelka ni bilo mogoče dodati v košarico.'); return; }
        openDrawer(cartDrawer); renderCart();
        document.dispatchEvent(new CustomEvent('gsh:cart:add', { detail: { value: (res.data.final_price/100), currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR', items: [{ item_id: res.data.sku || res.data.id, item_name: res.data.product_title }] } }));
        if (btn && isCard) { btn.textContent = 'Dodano ✓'; setTimeout(restore, 1300); }
        else restore();
      })
      .catch(function(){ restore(); showToast('Prišlo je do napake. Poskusi znova.'); });
  });

  function showToast(msg){
    var t = document.querySelector('.gsh-toast');
    if (!t) { t = document.createElement('div'); t.className = 'gsh-toast'; document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-visible');
    clearTimeout(t._hideTimer); t._hideTimer = setTimeout(function(){ t.classList.remove('is-visible'); }, 3500);
  }

  /* ---------- Wishlist (localStorage of product handles) ---------- */
  function getWishlist(){ try { return JSON.parse(localStorage.getItem('gsh_wishlist')||'[]'); } catch(e){ return []; } }
  function setWishlist(ids){ try { localStorage.setItem('gsh_wishlist', JSON.stringify(ids)); } catch(e){} }
  function wishlistProducts(){ return getWishlist().filter(function(h){ return typeof h === 'string' && h.indexOf('article-') !== 0; }); }
  function updateWishCount(){
    var n = wishlistProducts().length;
    qsa('[data-gsh-wishlist-count]').forEach(function(c){ c.textContent = n; c.hidden = n === 0; });
  }
  function syncHearts(){
    var list = getWishlist();
    qsa('[data-gsh-wishlist-toggle]').forEach(function(btn){ btn.classList.toggle('is-active', list.indexOf(btn.getAttribute('data-gsh-wishlist-toggle')) >= 0); });
  }
  function toggleWishlist(id){
    var list = getWishlist();
    var i = list.indexOf(id);
    if (i>=0) list.splice(i,1); else list.push(id);
    setWishlist(list);
    var added = list.indexOf(id) >= 0;
    qsa('[data-gsh-wishlist-toggle="'+id+'"]').forEach(function(btn){ btn.classList.toggle('is-active', added); });
    updateWishCount();
    if (wishDrawer && wishDrawer.classList.contains('is-open')) renderWishlist();
    /* Seznam želja na računu (B1): gsh-wishlist-sync.js posluša ta dogodek.
       Tu se strežnika namenoma ne dotikamo — srce mora delati tudi brez njega. */
    gshTrack(added ? 'wishlist_add' : 'wishlist_remove', { handle: id });
    try { document.dispatchEvent(new CustomEvent('gsh:wishlist:change', { detail: { handle: id, added: added } })); } catch(e){}
  }
  /* Edini vhod za gsh-wishlist-sync.js: prebrati seznam in ga postaviti na
     stanje strežnika. Izris src in števca ostane tu, na enem mestu. */
  window.gshWishlist = {
    get: function(){ return getWishlist(); },
    set: function(list){
      if (!Array.isArray(list)) return;
      setWishlist(list);
      syncHearts(); updateWishCount();
      if (wishDrawer && wishDrawer.classList.contains('is-open')) renderWishlist();
    },
    /* Tiha odstranitev: uporablja se, ko strežnik zavrne dodajanje (poln
       seznam). Dogodka NE sproži — sicer bi za izdelek, ki na računu sploh
       ni pristal, poslali še brisanje. */
    remove: function(id){
      var list = getWishlist(), i = list.indexOf(id);
      if (i < 0) return;
      list.splice(i,1); setWishlist(list);
      syncHearts(); updateWishCount();
      if (wishDrawer && wishDrawer.classList.contains('is-open')) renderWishlist();
    }
  };
  document.addEventListener('gsh:toast', function(e){ if (e && e.detail && e.detail.message) showToast(e.detail.message); });
  function renderWishlist(){
    var handles = wishlistProducts();
    var wrap = qs('[data-gsh-wishlist-items]'), empty = qs('[data-gsh-wishlist-empty]');
    if (!wrap) return;
    updateWishCount();
    if (!handles.length){ wrap.innerHTML=''; if (empty) empty.hidden = false; return; }
    if (empty) empty.hidden = true;
    wrap.innerHTML = '<div class="gsh-cart-loading" style="padding:30px;text-align:center;color:var(--muted)">Nalagam…</div>';
    Promise.all(handles.map(function(h){
      return fetch('/products/'+h+'.js').then(function(r){ return r.ok ? r.json() : null; }).catch(function(){ return null; });
    })).then(function(items){
      var html = items.filter(Boolean).map(function(p){
        var v = (p.variants||[]).filter(function(x){ return x.available; })[0] || (p.variants||[])[0] || {};
        var img = p.featured_image || (p.images && p.images[0]) || '';
        return '<div class="gsh-cart-line gsh-wish-line" data-handle="'+p.handle+'">'+
          '<a href="'+p.url+'" class="gsh-cart-line__media"><img src="'+thumb(img,120)+'" width="72" height="72" alt="'+escapeHtml(p.title)+'" loading="eager"></a>'+
          '<div class="gsh-cart-line__info">'+
            (p.vendor ? '<div class="gsh-cart-line__vendor">'+escapeHtml(p.vendor)+'</div>' : '')+
            '<a href="'+p.url+'" class="gsh-cart-line__title">'+escapeHtml(p.title)+'</a>'+
            '<div class="gsh-cart-line__price" style="text-align:left;font-size:15px">'+money(v.price||p.price)+'</div>'+
            '<div class="gsh-cart-line__ctrls">'+
              (v.available ? '<button type="button" class="gsh-wish-line__add" data-gsh-cart-quickadd data-id="'+v.id+'">V košarico</button>' : '<span class="gsh-wish-line__soldout">Razprodano</span>')+
              '<button type="button" class="gsh-cart-line__remove" data-gsh-wish-remove data-handle="'+p.handle+'">Odstrani</button>'+
            '</div>'+
          '</div>'+
        '</div>';
      }).join('');
      wrap.innerHTML = html || '';
      if (!html && empty) empty.hidden = false;
    });
  }

  /* ---------- PDP variant picker (radio → hidden id + price + availability) ---------- */
  document.addEventListener('change', function(e){
    var r = e.target.closest('[data-gsh-variant-radio]');
    if (!r) return;
    var form = document.getElementById('gsh-product-form');
    if (form){ var idIn = form.querySelector('[name="id"]'); if (idIn) idIn.value = r.value; }
    qsa('.gsh-pdp__variant').forEach(function(l){ l.classList.toggle('is-selected', l.contains(r)); });
    var price = parseInt(r.getAttribute('data-price'), 10) || 0;
    var avail = r.getAttribute('data-available') === 'true';
    qsa('[data-gsh-atc-price]').forEach(function(s){ s.textContent = money(price); });
    var atc = form && form.querySelector('[data-gsh-atc-btn]');
    if (atc){ atc.disabled = !avail; atc.innerHTML = avail ? 'Dodaj v košarico — <span data-gsh-atc-price>'+money(price)+'</span>' : 'Ni na zalogi'; }
    var notify = qs('[data-gp-notify]');
    if (notify){ notify.setAttribute('data-gp-notify-soldout', avail ? '' : 'true'); syncNotify(); }
  });

  /* ---------- "Obvesti me, ko bo spet na zalogi" ----------
     Gumb nosi razred SI_trigger; nanj se veze aplikacija Appikon "Back In Stock"
     (SI.popup.settings.trigger === 'SI_trigger', generic_trigger_handler: true).
     Pokazemo ga SAMO, ce je aplikacija res naložena -- sicer bi bil to gumb, ki
     ne odpre nicesar. Aplikacija se nalozi z defer, zato nekaj sekund poskusamo. */
  function syncNotify(){
    var n = qs('[data-gp-notify]');
    if (!n) return;
    var soldOut = n.getAttribute('data-gp-notify-soldout') === 'true';
    n.hidden = !(soldOut && window.SI && window.SI.popup);
  }
  (function(){
    if (!qs('[data-gp-notify]')) return;
    var tries = 0;
    (function poll(){
      syncNotify();
      if (window.SI && window.SI.popup) return;
      if (++tries > 40) return;           /* ~10 s, nato odneha in gumb ostane skrit */
      setTimeout(poll, 250);
    })();
  })();

  /* ---------- Gallery (thumbnail switch) ---------- */
  document.addEventListener('click', function(e){
    var thumb = e.target.closest('[data-gsh-gallery-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('.gsh-pdp__gallery');
    var main = gallery && gallery.querySelector('[data-gsh-gallery-main] img');
    var thumbImg = thumb.querySelector('img');
    if (main && thumbImg) main.src = thumbImg.src.replace(/width=\d+/, 'width=1000');
    qsa('[data-gsh-gallery-thumb]', gallery).forEach(function(t){ t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  });

  /* ---------- Facets (collection filters, multi-select + price) ---------- */
  document.addEventListener('change', function(e){
    if (!e.target.matches('[data-gsh-facet-param], [data-gsh-sort-select]')) return;
    var url = new URL(window.location.href);
    url.searchParams.delete('page');
    if (e.target.matches('[data-gsh-sort-select]')) {
      url.searchParams.set('sort_by', e.target.value);
    } else {
      var param = e.target.getAttribute('data-gsh-facet-param');
      var val = e.target.getAttribute('data-gsh-facet-value');
      if (e.target.checked) {
        url.searchParams.append(param, val);
      } else {
        var kept = url.searchParams.getAll(param).filter(function(v){ return v !== val; });
        url.searchParams.delete(param);
        kept.forEach(function(v){ url.searchParams.append(param, v); });
      }
    }
    window.location.href = url.toString();
  });
  document.addEventListener('click', function(e){
    var apply = e.target.closest('[data-gsh-price-apply]');
    if (!apply) return;
    var box = apply.closest('.gsh-filter-price');
    var min = box.querySelector('[data-gsh-price-min]').value.trim();
    var max = box.querySelector('[data-gsh-price-max]').value.trim();
    var url = new URL(window.location.href);
    url.searchParams.delete('page');
    var minP = apply.getAttribute('data-min-param'), maxP = apply.getAttribute('data-max-param');
    if (min) url.searchParams.set(minP, min); else url.searchParams.delete(minP);
    if (max) url.searchParams.set(maxP, max); else url.searchParams.delete(maxP);
    window.location.href = url.toString();
  });

  /* ---------- Instant search (Algolia-enterprise style) ---------- */
  var searchInput = qs('[data-gsh-search-input]');
  var searchResults = qs('[data-gsh-search-results]');
  var searchSide = qs('[data-gsh-search-side]');
  var searchHint = qs('[data-gsh-search-hint]');
  var searchClear = qs('[data-gsh-search-clear]');
  var searchTimer, searchNavIdx = -1;

  function searchShowDefault(){
    if (searchResults){ searchResults.hidden = true; searchResults.innerHTML = ''; }
    if (searchSide){ searchSide.hidden = true; searchSide.innerHTML = ''; }
    if (searchHint) searchHint.hidden = false;
    if (searchClear) searchClear.hidden = true;
    searchNavIdx = -1;
  }

  function searchRender(suggest, products, q, concept, helps){
    if (!searchResults) return;
    var res = (suggest && suggest.resources && suggest.resources.results) || {};
    var collections = res.collections || [];
    products = products || [];
    helps = helps || [];
    if (searchHint) searchHint.hidden = true;

    // side column: concept collections, then suggested collections, then help links
    var side = '';
    var conceptCols = (concept && concept.cols) ? concept.cols : [];
    if (conceptCols.length || collections.length){
      side += '<div class="gsh-search-col__title">Kolekcije</div>';
      conceptCols.forEach(function(c){ side += '<a class="gsh-search-sug" data-gsh-nav href="/collections/'+c[1]+'">'+escapeHtml(c[0])+'</a>'; });
      collections.slice(0,8).forEach(function(c){ side += '<a class="gsh-search-sug" data-gsh-nav href="'+c.url+'">'+escapeHtml(c.title)+'</a>'; });
    }
    if (helps.length){
      side += '<div class="gsh-search-col__title">Pomoč</div>';
      helps.forEach(function(h){ side += '<a class="gsh-search-sug" data-gsh-nav href="'+h.href+'">'+escapeHtml(h.label)+' →</a>'; });
    }
    if (searchSide){ searchSide.innerHTML = side; searchSide.hidden = !side; }

    if (!products.length && !side){
      searchResults.innerHTML = '<div class="gsh-search-empty">Ni zadetkov za <strong>'+escapeHtml(q)+'</strong>. Poskusi z drugim izrazom.</div>';
      searchResults.hidden = false; if (searchClear) searchClear.hidden = false; return;
    }

    var note = concept ? '<div class="gsh-search-concept">Prikazujem izbor za: <strong>'+escapeHtml(concept.label)+'</strong></div>' : '';
    if (products.length){
      var main = '<div class="gsh-search-grid">'+products.map(function(p){
        var img = p.image || '';
        var price = p.price || '';
        if (price && /^[\d.,\s]+$/.test(price)) price = price.trim().replace(/\.(\d{2})$/, ',$1') + ' €';
        return '<a class="gsh-search-card" data-gsh-nav href="'+p.url+'">'+
          '<span class="gsh-search-card__media"><img src="'+thumb(img,320)+'" alt="'+escapeHtml(p.title)+'" loading="eager"></span>'+
          '<span class="gsh-search-card__brand">'+escapeHtml(p.vendor||'')+'</span>'+
          '<span class="gsh-search-card__title">'+escapeHtml(p.title)+'</span>'+
          '<span class="gsh-search-card__price">'+price+'</span>'+
        '</a>';
      }).join('')+'</div>';
      var allQ = concept ? concept.q : q;
      searchResults.innerHTML = note +
        '<div class="gsh-search-col__title gsh-search-col__title--main">Izdelki za &laquo;'+escapeHtml(q)+'&raquo; · '+products.length+'</div>'+main+
        '<a class="gsh-search-results__all" href="/search?q='+encodeURIComponent(allQ)+'&type=product">Odpri vse rezultate →</a>';
    } else {
      searchResults.innerHTML = note + '<div class="gsh-search-empty">Poglej povezane predloge levo za &laquo;'+escapeHtml(q)+'&raquo;.</div>';
    }
    searchResults.hidden = false; if (searchClear) searchClear.hidden = false;
    searchNavIdx = -1;
  }

  /* Concept matcher — connects a spoken concern (SL/EN/FR, incl. "stara koža") to
     real products + collections, so the search never comes up empty for a concept. */
  var CONCEPTS = [
    { re:/stara\s?ko|star[ae]\s?ko|zrel|staran|gub[ae]|wrinkl|anti.?ag|aging|vieill|\brides?\b|kolagen|collagen|peptid/i, label:'Zrela koža · anti-aging', q:'retinol', cols:[['Gube','gube'],['Zrela koža','zrela-koza']] },
    { re:/akn|mozolj|acne|bouton|breakout|nečist|necist|zamašen|zamasen/i, label:'Akne · nečistoče', q:'BHA salicilna', cols:[['Aknasta koža','aknasta-koza']] },
    { re:/\bsuh|dehidr|\bdry\b|hidrac|\bsec|thirsty/i, label:'Suha · dehidrirana koža', q:'hialuronska', cols:[['Suha koža','suha-koza']] },
    { re:/rde[cč]|občutlj|obcutlj|redness|sensitiv|rouge|irrit|pomir/i, label:'Rdečica · občutljiva koža', q:'centella cica', cols:[['Rdečica','rdecica'],['Občutljiva','obcutljiva-koza']] },
    { re:/pigment|made[žz]|temne\s?made|hyperpig|tache|melasm|lise|posvetl|brighten|[ée]clat/i, label:'Pigmentacija · sijaj', q:'vitamin c niacinamid', cols:[['Pigmentacija','pigmentacija']] },
    { re:/\bpor[ei]\b|razširjene|razsirjene|mast|oily|sebum|gras|svetlik/i, label:'Mastna koža · pore', q:'niacinamid', cols:[['Mastna koža','mastna-koza'],['Razširjene pore','razsirjene-pore']] },
    { re:/barier|pregrad|barrier|obnov/i, label:'Kožna pregrada', q:'ceramid', cols:[['Občutljiva','obcutljiva-koza']] },
    { re:/son[cč]|\bspf\b|\buv\b|zaščit|zascit|\bsun\b|soleil/i, label:'Zaščita pred soncem', q:'SPF', cols:[] }
  ];
  var HELP_CONCEPTS = [
    { re:/vra[cč]il|refund|return|reklamac|denar\s?nazaj/i, label:'Vračila in vračilo denarja', href:'/pages/pomoc#legal-refund-policy' },
    { re:/dostav|shipping|paket|pošilj|posilj|livr|kdaj\s?prispe/i, label:'Dostava in pošiljanje', href:'/pages/pomoc#legal-shipping-policy' },
    { re:/pla[cč]il|payment|kartic|paiement|obro/i, label:'Načini plačila', href:'/pages/pomoc#legal-terms-of-service' },
    { re:/zasebn|privacy|gdpr|piškot|piskot|cookie|podatk/i, label:'Zasebnost in piškotki', href:'/pages/pomoc#legal-privacy-policy' }
  ];
  function matchConcept(q){ for(var i=0;i<CONCEPTS.length;i++){ if(CONCEPTS[i].re.test(q)) return CONCEPTS[i]; } return null; }
  function matchHelp(q){ var out=[]; for(var i=0;i<HELP_CONCEPTS.length;i++){ if(HELP_CONCEPTS[i].re.test(q)) out.push(HELP_CONCEPTS[i]); } return out; }

  if (searchInput){
    searchInput.addEventListener('input', function(){
      clearTimeout(searchTimer);
      var q = searchInput.value.trim();
      if (searchClear) searchClear.hidden = !q;
      if (q.length < 2){ searchShowDefault(); return; }
      searchResults.innerHTML = '<div class="gsh-search-loading">Iščem…</div>'; searchResults.hidden = false; if (searchHint) searchHint.hidden = true;
      searchTimer = setTimeout(function(){
        var C = matchConcept(q), helps = matchHelp(q);
        var productQ = C ? C.q : q;
        Promise.all([
          fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=collection&resources[limit]=8').then(function(r){ return r.json(); }).catch(function(){ return {}; }),
          fetch('/search?q='+encodeURIComponent(productQ)+'&type=product&view=ajax').then(function(r){ return r.json(); }).catch(function(){ return []; })
        ]).then(function(arr){ searchRender(arr[0], arr[1], q, C, helps); }).catch(function(){});
      }, 180);
    });
    searchInput.addEventListener('keydown', function(e){
      var items = qsa('[data-gsh-nav]', searchResults);
      if ((e.key === 'ArrowDown') && items.length){ e.preventDefault(); searchNavIdx = Math.min(items.length-1, searchNavIdx+1); }
      else if ((e.key === 'ArrowUp') && items.length){ e.preventDefault(); searchNavIdx = Math.max(0, searchNavIdx-1); }
      else if (e.key === 'Enter' && searchNavIdx >= 0 && items[searchNavIdx]){ e.preventDefault(); window.location.href = items[searchNavIdx].getAttribute('href'); return; }
      else return;
      items.forEach(function(it,i){ it.classList.toggle('is-nav', i === searchNavIdx); });
      if (items[searchNavIdx]) items[searchNavIdx].scrollIntoView({ block:'nearest' });
    });
  }

  document.addEventListener('click', function(e){
    if (e.target.closest('[data-gsh-search-clear]')){ if (searchInput){ searchInput.value = ''; searchInput.focus(); } searchShowDefault(); return; }
    var chip = e.target.closest('[data-gsh-search-term]');
    if (chip && searchInput){ searchInput.value = chip.getAttribute('data-gsh-search-term'); searchInput.dispatchEvent(new Event('input')); searchInput.focus(); }
  });


  /* ---------- Cookie consent — blokirni modal + Shopify Customer Privacy API ---------- */
  (function(){
    var banner = qs('[data-gsh-cookie-banner]');
    if (!banner) return;

    function withPrivacyApi(cb){
      try{
        if (window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.setTrackingConsent){ cb(); return; }
        if (window.Shopify && Shopify.loadFeatures){
          Shopify.loadFeatures([{ name:'consent-tracking-api', version:'0.1' }], function(err){
            if (!err && window.Shopify.customerPrivacy) cb();
          });
        }
      }catch(e){}
    }
    function applyConsent(level){
      var granted = level === 'all';
      withPrivacyApi(function(){
        try{
          Shopify.customerPrivacy.setTrackingConsent({ analytics:granted, marketing:granted, preferences:granted, sale_of_data:granted }, function(){});
        }catch(e){}
      });
    }

    // Že izbrano prej → samo znova uveljavi soglasje, ne pokaži modala
    var saved = null;
    try { saved = localStorage.getItem('gsh_cookie'); } catch(e){}
    if (saved) { applyConsent(saved); return; }

    // Zastava iz ISO kode države
    var regionEl = banner.querySelector('[data-gsh-cc-region]');
    var flagEl = banner.querySelector('[data-gsh-cc-flag]');
    if (regionEl && flagEl){
      var iso = (regionEl.getAttribute('data-cc-iso') || '').trim().toUpperCase();
      if (iso.length === 2){
        try{ flagEl.textContent = String.fromCodePoint(0x1F1E6 + iso.charCodeAt(0) - 65, 0x1F1E6 + iso.charCodeAt(1) - 65); }catch(e){}
      }
    }

    // Blokirni prikaz takoj (zaklene scroll prek body.gsh-cookie-on)
    banner.hidden = false;
    banner.setAttribute('aria-hidden', 'false');
    document.body.classList.add('gsh-cookie-on');

    // Zapre se SAMO ob izbiri (klik na ozadje ne naredi nič)
    banner.addEventListener('click', function(e){
      var acc = e.target.closest('[data-gsh-cookie-accept]');
      var ess = e.target.closest('[data-gsh-cookie-essential]');
      if (!acc && !ess) return;
      var val = acc ? 'all' : 'essential';
      try{ localStorage.setItem('gsh_cookie', val); }catch(e){}
      applyConsent(val);
      banner.hidden = true;
      banner.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('gsh-cookie-on');
    });
  })();

  /* ---------- Sticky ATC reveal ---------- */
  var stickyAtc = qs('[data-gsh-sticky-atc]');
  if (stickyAtc) {
    window.addEventListener('scroll', function(){
      stickyAtc.classList.toggle('is-visible', window.scrollY > 600);
    }, { passive: true });
  }

  /* ---------- Mobile menu (drill-down) ---------- */
  /* The menu is authored inside the header group, which uses transform/will-change for the
     hide-on-scroll effect — that traps position:fixed to the header, so the menu's height:100%
     collapses to the header height (~87px) and clips all links. Re-parent it to <body>. */
  (function(){ var _nav = qs('[data-gsh-mobile-menu]'); if (_nav && _nav.parentNode !== document.body) document.body.appendChild(_nav); })();
  function mnavShow(id){
    var nav = qs('[data-gsh-mobile-menu]'); if (!nav) return;
    qsa('.gsh-mnav__panel', nav).forEach(function(p){ p.classList.toggle('is-active', p.getAttribute('data-panel') === id); });
    var vp = qs('.gsh-mnav__viewport', nav); if (vp) vp.scrollTop = 0;
  }
  document.addEventListener('click', function(e){
    if (e.target.closest('[data-gsh-mobile-open]')){ qs('[data-gsh-mobile-menu]').classList.add('is-open'); document.documentElement.style.overflow='hidden'; }
    if (e.target.closest('[data-gsh-mobile-close]')){ qs('[data-gsh-mobile-menu]').classList.remove('is-open'); document.documentElement.style.overflow=''; setTimeout(function(){ mnavShow('root'); }, 320); }
    var drill = e.target.closest('[data-drill]'); if (drill && drill.closest('[data-gsh-mobile-menu]')){ mnavShow(drill.getAttribute('data-drill')); }
    var back = e.target.closest('[data-back]'); if (back && back.closest('[data-gsh-mobile-menu]')){ mnavShow(back.getAttribute('data-back')); }
    /* Any real navigation link inside the menu closes it (incl. same-page anchor links
       like the footer policy links, which otherwise leave the menu open over the page). */
    var mlink = e.target.closest('[data-gsh-mobile-menu] a[href]');
    if (mlink){ var mnav = qs('[data-gsh-mobile-menu]'); if (mnav){ mnav.classList.remove('is-open'); document.documentElement.style.overflow=''; setTimeout(function(){ mnavShow('root'); }, 320); } }
  });

  /* ---------- Carousel dots layout ---------- */
  document.addEventListener('click', function(e){
    var dot = e.target.closest('.gsh-carousel-dots button');
    if (!dot) return;
    var gallery = dot.closest('.gsh-pdp__gallery');
    var idx = Array.prototype.indexOf.call(dot.parentNode.children, dot);
    var thumbs = gallery.querySelectorAll('[data-gsh-gallery-thumb]');
    if (thumbs[idx]) thumbs[idx].click();
    Array.prototype.forEach.call(dot.parentNode.children, function(d){ d.classList.remove('is-active'); });
    dot.classList.add('is-active');
  });

  /* ---------- Mega menu accessibility (hover + keyboard) ---------- */
  qsa('[data-gsh-mega-trigger]').forEach(function(li){
    var link = li.querySelector('.gsh-header__nav-link');
    var menu = li.querySelector('.gsh-mega-menu');
    if (!menu) return;
    function openMega(){ menu.classList.add('is-open'); li.classList.add('is-open'); link.setAttribute('aria-expanded','true'); }
    function closeMega(){ menu.classList.remove('is-open'); li.classList.remove('is-open'); link.setAttribute('aria-expanded','false'); }
    li.addEventListener('mouseenter', openMega);
    li.addEventListener('mouseleave', closeMega);
    link.addEventListener('focus', openMega);
    li.addEventListener('keydown', function(e){ if (e.key === 'Escape') { closeMega(); link.focus(); } });
    document.addEventListener('focusin', function(e){ if (!li.contains(e.target)) closeMega(); });
  });

  /* ---------- Brands mega — A–Z letter switching ---------- */
  qsa('.gsh-brands-mega').forEach(function(bm){
    bm.addEventListener('click', function(e){
      var btn = e.target.closest('.gsh-brands-mega__letter');
      if (!btn) return;
      var L = btn.getAttribute('data-letter');
      qsa('.gsh-brands-mega__letter', bm).forEach(function(b){ b.classList.toggle('is-active', b === btn); });
      qsa('.gsh-brands-mega__panel', bm).forEach(function(p){ p.classList.toggle('is-active', p.getAttribute('data-letter') === L); });
    });
  });

  /* ---------- Focus trap for open drawers/modals ---------- */
  document.addEventListener('gsh:drawer:open', function(e){
    if (window.GSHVendor && e.detail && e.detail.el) window.GSHVendor.trapFocus(e.detail.el);
  });

  /* ---------- Before/After comparison slider (PDP results) ---------- */
  qsa('[data-gsh-ba]').forEach(function(wrap){
    var range = wrap.parentNode.querySelector('[data-gsh-ba-range]') || wrap.querySelector('[data-gsh-ba-range]');
    var top = wrap.querySelector('[data-gsh-ba-top]');
    var handle = wrap.querySelector('[data-gsh-ba-handle]');
    if (!range || !top || !handle) return;
    function set(v){ top.style.clipPath = 'inset(0 ' + (100 - v) + '% 0 0)'; handle.style.left = v + '%'; }
    range.addEventListener('input', function(){ set(range.value); });
    set(range.value);
  });

  /* ---------- PDP buy box: purchase mode (one-time / subscribe) + volume tiers + live total ---------- */
  qsa('[data-gsh-buy]').forEach(function(buy){
    var base = parseInt(buy.getAttribute('data-base-price'), 10) || 0;
    var qtyInput = qs('[data-gsh-qty-input]', buy);
    var spInput = qs('[data-gsh-sp-input]', buy);
    var plansWrap = qs('[data-gsh-plans]', buy);
    function readState(){
      var modeEl = qs('[data-gsh-mode]:checked', buy);
      var tierEl = qs('[data-gsh-tier]:checked', buy);
      var planEl = qs('[data-gsh-plan]:checked', buy);
      return {
        mode: modeEl ? modeEl.getAttribute('data-gsh-mode') : 'onetime',
        qty: tierEl ? (parseInt(tierEl.getAttribute('data-qty'), 10) || 1) : 1,
        disc: tierEl ? (parseInt(tierEl.getAttribute('data-discount'), 10) || 0) : 0,
        spPrice: planEl ? (parseInt(planEl.getAttribute('data-sp-price'), 10) || base) : base,
        planEl: planEl
      };
    }
    // Subscription price wins and is NOT stacked with the volume % (the automatic cart discount does not combine with a selling plan).
    function unitFor(disc, s){ return s.mode === 'subscribe' ? s.spPrice : Math.round(base * (100 - disc) / 100); }
    function recompute(){
      var s = readState();
      buy.classList.toggle('is-sub', s.mode === 'subscribe');
      qsa('[data-gsh-tier]', buy).forEach(function(t){
        var q = parseInt(t.getAttribute('data-qty'), 10) || 1;
        var d = parseInt(t.getAttribute('data-discount'), 10) || 0;
        var lbl = t.closest('.gsh-tier,.gp-tier');
        var tot = lbl && qs('[data-gsh-tier-total]', lbl);
        if (tot) tot.textContent = money(unitFor(d, s) * q);
      });
      if (qtyInput) qtyInput.value = s.qty;
      if (spInput){
        if (s.mode === 'subscribe' && s.planEl){ spInput.disabled = false; spInput.value = s.planEl.value; }
        else { spInput.disabled = true; spInput.value = ''; }
      }
      var grand = unitFor(s.disc, s) * s.qty;
      qsa('[data-gsh-buy-total]').forEach(function(el){ el.textContent = money(grand); });
    }
    buy.addEventListener('change', function(e){
      if (e.target.closest('[data-gsh-tier]')) qsa('.gsh-tier,.gp-tier', buy).forEach(function(l){ l.classList.toggle('is-selected', l.contains(e.target)); });
      if (e.target.closest('[data-gsh-mode]')){
        var sub = e.target.getAttribute('data-gsh-mode') === 'subscribe';
        if (plansWrap) plansWrap.hidden = !sub;
        qsa('.gsh-buy__mode', buy).forEach(function(l){ l.classList.toggle('is-active', l.contains(e.target)); });
      }
      if (e.target.closest('[data-gsh-plan]')) qsa('.gsh-buy__plan', buy).forEach(function(l){ l.classList.toggle('is-selected', l.contains(e.target)); });
      recompute();
    });
    recompute();
  });

  /* ---------- Magical hover: pointer-tracked glow on PDP cards ---------- */
  (function(){
    var glowSel = '.gsh-ritual-card, .gsh-formula-card, .gsh-protocol-card, .gsh-tier, .gsh-community__cell';
    if (window.matchMedia && window.matchMedia('(hover: none)').matches) return; // skip on touch — no cursor to track
    document.addEventListener('pointermove', function(e){
      var card = e.target.closest && e.target.closest(glowSel);
      if (!card) return;
      var r = card.getBoundingClientRect();
      card.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100) + '%');
      card.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100) + '%');
    }, { passive: true });
  })();

  /* ---------- Premium: scroll reveal + header elevation ---------- */
  document.documentElement.classList.add('gsh-js');
  (function(){
    var sel = '.gsh-pdp-sec, .gsh-sec-head, .gsh-cats__grid, .gsh-featured, .gsh-entry, .gsh-method__step, .gsh-hub-art, .gsh-hub-featured, .gsh-club-step, .gsh-club-tier, .gsh-about-value, .gsh-about-stat, .gsh-manifest__text, .gsh-manifest__emblem, .gsh-newsletter, .gsh-brands__group, .gsh-help-topic, .gsh-ingredient__what';
    var els = qsa(sel);
    if (!('IntersectionObserver' in window) || !els.length) return;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if (en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    var vh = window.innerHeight || 800;
    els.forEach(function(el){
      // Only hide+animate elements that start below the fold — avoids any flash for above-fold content.
      if (el.getBoundingClientRect().top > vh * 0.82){ el.classList.add('gsh-reveal'); io.observe(el); }
    });
  })();
  (function(){
    var hdr = qs('.gsh-header');
    var grp = qs('.shopify-section-group-header-group') || hdr;
    if (!hdr) return;
    var root = document.documentElement, lastY = window.pageYOffset || 0, ticking = false;
    function apply(){
      var y = window.pageYOffset || 0;
      var h = grp ? grp.offsetHeight : 120;
      hdr.classList.toggle('is-scrolled', y > 10);
      if (root.classList.contains('gsh-drawer-open')) { lastY = y; ticking = false; return; } // never hide while a drawer/menu is open
      if (y <= h) { root.classList.remove('gsh-head-hidden'); }              // always visible near the top
      else if (y > lastY + 4) { root.classList.add('gsh-head-hidden'); }     // scrolling down → hide
      else if (y < lastY - 4) { root.classList.remove('gsh-head-hidden'); }  // scrolling up → reveal instantly
      lastY = y; ticking = false;
    }
    window.addEventListener('scroll', function(){ if (!ticking) { requestAnimationFrame(apply); ticking = true; } }, { passive: true });
    apply();
  })();

  /* ---------- Compare (localStorage, full curated data, max 4) ---------- */
  function getCompare(){ try { var a=JSON.parse(localStorage.getItem('gsh_compare_v2')||'[]'); return Array.isArray(a)?a.filter(function(x){return x&&x.h;}):[]; } catch(e){ return []; } }
  function setCompare(a){ try { localStorage.setItem('gsh_compare_v2', JSON.stringify(a)); } catch(e){} }
  function syncCompareBtns(){ var l=getCompare(); qsa('[data-gsh-compare-toggle]').forEach(function(b){ b.classList.toggle('is-active', l.some(function(x){return x.h===b.getAttribute('data-gsh-compare-toggle');})); }); }
  function renderCompareBar(){
    var bar=qs('[data-gsh-compare-bar]'); if(!bar) return;
    var l=getCompare(), slots=qs('[data-gsh-compare-slots]');
    if(!l.length){ bar.hidden=true; if(slots) slots.innerHTML=''; return; }
    bar.hidden=false;
    if(slots) slots.innerHTML=l.map(function(p){ return '<span class="gsh-compare-slot"><img src="'+(p.img||'')+'" width="40" height="40" alt="'+escapeHtml(p.t||'')+'" loading="eager"><button type="button" data-gsh-compare-toggle="'+p.h+'" class="gsh-compare-slot__x" aria-label="Odstrani iz primerjave">✕</button></span>'; }).join('');
    var open=qs('[data-gsh-compare-open]'); if(open) open.textContent='Primerjaj ('+l.length+')';
  }
  function toggleCompare(h, json){
    var l=getCompare(), i=-1, k; for(k=0;k<l.length;k++){ if(l[k].h===h){ i=k; break; } }
    if(i>=0){ l.splice(i,1); }
    else { if(l.length>=4){ showToast('Primerjaš lahko največ 4 izdelke.'); return; } var d={h:h}; if(json){ try{ d=JSON.parse(json)||{}; }catch(e){ d={}; } d.h=h; } l.push(d); }
    setCompare(l); syncCompareBtns(); renderCompareBar();
  }
  function cmpPlural(n){ if(n===1) return 'izdelek'; if(n===2) return 'izdelka'; if(n===3||n===4) return 'izdelki'; return 'izdelkov'; }
  function cmpCell(v){ v=(v==null?'':(''+v)).trim(); return v?escapeHtml(v).replace(/·/g,'<span class="gsh-cmp-dot">·</span>'):'<span class="gsh-cmp-empty">—</span>'; }
  function openCompare(){
    var items=getCompare(); if(!items.length) return;
    var modal=qs('[data-gsh-compare-modal]'), table=qs('[data-gsh-compare-table]');
    var cnt=qs('[data-gsh-compare-count]'); if(cnt) cnt.textContent=items.length+' '+cmpPlural(items.length);
    var hasTl=items.some(function(p){ return (p.tl||'').trim(); });
    var CIC={
      skin:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9 3.5a7 7 0 0 0-2.9 12.2c.6.5 1 1.2 1 2v.8a2.5 2.5 0 0 0 2.5 2.5h1"/><path d="M15 8.5a1 1 0 1 0 0-.01M9 9a1 1 0 1 0 0-.01"/><path d="M12.5 12.5c0 1-1 1.5-1.5 1.5"/></svg>',
      ing:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="5" cy="6" r="2"/><circle cx="19" cy="9" r="2"/><circle cx="10" cy="18" r="2"/><path d="M6.7 7.2 8.3 16.2M11.9 16.9 17.2 10.6"/></svg>',
      how:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2.5s6 6.4 6 11a6 6 0 0 1-12 0c0-4.6 6-11 6-11Z"/></svg>',
      when:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M2 12h2M20 12h2M4.9 4.9l1.5 1.5M17.6 17.6l1.5 1.5M19.1 4.9l-1.5 1.5M6.4 17.6l-1.5 1.5"/></svg>'
    };
    function lbl(k,t){ return '<span class="gsh-cmp-lbl"><span class="gsh-cmp-ic">'+CIC[k]+'</span><span class="gsh-cmp-lbl-t">'+t+'</span></span>'; }
    var rows=[];
    rows.push(['', items.map(function(p){ return '<a href="'+(p.u||'#')+'" class="gsh-compare-cell__media"><img src="'+(p.img||'')+'" width="120" height="120" alt="'+escapeHtml(p.t||'')+'" loading="eager"></a>'; })]);
    rows.push(['', items.map(function(p){ var tag=(p.b||'').trim()?'<span class="gsh-compare-tag">'+escapeHtml(p.b)+'</span>':''; return '<span class="gsh-compare-cell__brand">'+escapeHtml(p.v||'')+'</span><a href="'+(p.u||'#')+'" class="gsh-compare-cell__name">'+escapeHtml(p.t||'')+'</a>'+tag; })]);
    rows.push(['', items.map(function(p){ var pr='<span class="gsh-compare-cell__price">'+money(p.price)+'</span>'; var st=p.avail?'<span class="gsh-compare-cell__stock">✓ Na zalogi</span>':'<span class="gsh-compare-cell__stock is-out">Razprodano</span>'; return pr+st; })]);
    rows.push(['', items.map(function(p){ return p.avail&&p.vid?'<button type="button" class="gsh-btn gsh-btn--primary gsh-compare-cell__add" data-gsh-cart-quickadd data-id="'+p.vid+'">V košarico</button>':'<a href="'+(p.u||'#')+'" class="gsh-btn gsh-btn--ghost gsh-compare-cell__add">Poglej izdelek</a>'; })]);
    rows.push([lbl('skin','Za katero kožo'), items.map(function(p){ return cmpCell(p.s); })]);
    rows.push([lbl('ing','Ključne sestavine'), items.map(function(p){ return cmpCell(p.i); })]);
    rows.push([lbl('how','Kako uporabiti'), items.map(function(p){ return cmpCell(p.ht); })]);
    if(hasTl) rows.push([lbl('when','Kdaj pričakovati učinek'), items.map(function(p){ return cmpCell(p.tl); })]);
    var html='<table class="gsh-compare-table"><tbody>';
    rows.forEach(function(r,ri){ html+='<tr'+(ri<4?' class="gsh-compare-table__hd"':'')+'><th>'+r[0]+'</th>'+r[1].map(function(c){return '<td>'+c+'</td>';}).join('')+'</tr>'; });
    table.innerHTML=html+'</tbody></table>';
    var foot=qs('[data-gsh-compare-foot]');
    if(foot){ var goals=items.map(function(p){return (p.b||'').trim().toLowerCase();}).filter(Boolean); var uniq=goals.filter(function(x,ix){return goals.indexOf(x)===ix;}); if(uniq.length){ foot.hidden=false; foot.innerHTML='<span class="gsh-compare-foot__badge">GSH</span><span class="gsh-compare-foot__lbl">GSH hitra izbira</span><span class="gsh-compare-foot__sep"></span><span class="gsh-compare-foot__goals">Izberi po glavnem cilju: '+uniq.map(function(g){return '<b>'+escapeHtml(g)+'</b>';}).join(' · ')+'</span>'; } else { foot.hidden=true; foot.innerHTML=''; } }
    modal.classList.add('is-open'); modal.setAttribute('aria-hidden','false'); document.documentElement.style.overflow='hidden';
  }
  function closeCompare(){ var m=qs('[data-gsh-compare-modal]'); if(m){ m.classList.remove('is-open'); m.setAttribute('aria-hidden','true'); document.documentElement.style.overflow=''; } }
  document.addEventListener('click', function(e){
    var t=e.target.closest('[data-gsh-compare-toggle]'); if(t){ toggleCompare(t.getAttribute('data-gsh-compare-toggle'), t.getAttribute('data-gsh-compare-json')); return; }
    if(e.target.closest('[data-gsh-compare-open]')) openCompare();
    if(e.target.closest('[data-gsh-compare-clear]')){ setCompare([]); syncCompareBtns(); renderCompareBar(); }
    if(e.target.closest('[data-gsh-compare-close]')) closeCompare();
  });

  /* ---------- App bridge: Rivo loyalty ---------- */
  document.addEventListener('click', function(e){
    var lo = e.target.closest('[data-gsh-loyalty-open]');
    if (lo){
      e.preventDefault();
      var sel = lo.getAttribute('data-open-js');
      if (sel){ var t = document.querySelector(sel); if (t){ t.click(); return; } }
      if (window.Rivo && typeof window.Rivo.open === 'function'){ window.Rivo.open(); return; }
      if (window.$rivo && typeof window.$rivo.open === 'function'){ window.$rivo.open(); return; }
      var cand = ['#launcher-wrapper .ba-met-handler','#rivo-loyalty-launcher','[data-rivo-launcher]','.rivo-loyalty-launcher','#loyalty-launcher','.rivo-launcher'];
      for (var i=0;i<cand.length;i++){ var c=document.querySelector(cand[i]); if (c){ c.click(); return; } }
      window.location.href = '/pages/gsh-club';
      return;
    }
    /* Obveščanje o zalogi pokriva Appikon "Back In Stock": gumb .gp-notify__btn nosi
       razred SI_trigger, na katerega se aplikacija veže sama. Tu ni mostu — če
       aplikacije ni, se gumb sploh ne sme izrisati. */
  });

  /* ---------- Auth: forgot-password (recover) toggle ---------- */
  (function(){
    var loginView = qs('[data-gsh-login-view]'), recoverView = qs('[data-gsh-recover-view]');
    if (!recoverView) return;
    function showRecover(){ if (loginView) loginView.hidden = true; recoverView.hidden = false; }
    function showLogin(){ recoverView.hidden = true; if (loginView) loginView.hidden = false; }
    if (window.location.hash === '#recover' || recoverView.querySelector('.gsh-auth__ok')) showRecover();
    document.addEventListener('click', function(e){
      if (e.target.closest('[data-gsh-recover-open]')){ e.preventDefault(); showRecover(); }
      if (e.target.closest('[data-gsh-recover-close]')){ e.preventDefault(); showLogin(); }
    });
  })();

  /* ---------- Locale / currency modal ---------- */
  (function(){
    var modal = qs('[data-gsh-locale-modal]');
    if (!modal) return;
    /* The modal is authored inside the header group, which uses transform/will-change for the
       hide-on-scroll effect — that traps position:fixed to the header (modal shows at top, overlay
       covers only the header). Re-parent it to <body> so fixed covers the full viewport + centers. */
    if (modal.parentNode !== document.body) document.body.appendChild(modal);
    function open(){ modal.classList.add('is-open'); modal.setAttribute('aria-hidden','false'); document.body.style.overflow = 'hidden'; }
    function close(){ modal.classList.remove('is-open'); modal.setAttribute('aria-hidden','true'); document.body.style.overflow = ''; }
    document.addEventListener('click', function(e){
      if (e.target.closest('[data-gsh-locale-open]')){ e.preventDefault(); open(); }
      else if (e.target.closest('[data-gsh-locale-close]')){ e.preventDefault(); close(); }
    });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && modal.classList.contains('is-open')) close(); });
    var countrySel = modal.querySelector('[data-gsh-locale-country]');
    var currencyOut = modal.querySelector('[data-gsh-locale-currency]');
    if (countrySel && currencyOut){
      countrySel.addEventListener('change', function(){
        var opt = countrySel.options[countrySel.selectedIndex];
        var cur = opt && opt.getAttribute('data-currency');
        if (cur) currencyOut.textContent = cur;
      });
    }
  })();

  /* ---------- First visit: ask for country + language after the cookie banner ---------- */
  (function(){
    try { if (localStorage.getItem('gshLocaleSeen')) return; } catch(e){ return; }
    var modal = qs('[data-gsh-locale-modal]');
    if (!modal) return;
    function show(){
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden','false');
      document.body.style.overflow = 'hidden';
      try { localStorage.setItem('gshLocaleSeen','1'); } catch(e){}
    }
    var cookie = qs('[data-gsh-cookie]');
    var visible = cookie && cookie.offsetParent !== null && getComputedStyle(cookie).display !== 'none';
    if (visible){
      var t0 = Date.now();
      var iv = setInterval(function(){
        var gone = !cookie.offsetParent || getComputedStyle(cookie).display === 'none';
        if (gone){ clearInterval(iv); setTimeout(show, 350); }
        else if (Date.now() - t0 > 20000){ clearInterval(iv); show(); }
      }, 400);
    } else {
      setTimeout(show, 800);
    }
  })();

  /* ---------- Skin Hub article: quick-match quiz (Sanity embedded) ---------- */
  window.gshQmSelect = function(btn, skin){
    var root = btn.closest('.gsh-quick-match');
    if (!root) return;
    root.querySelectorAll('.gsh-qm__btn').forEach(function(b){ b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
    root.querySelectorAll('.gsh-qm__answer').forEach(function(a){
      var show = a.id === 'gsh-qm-ans-' + skin;
      if (show) { a.hidden = false; a.removeAttribute('hidden'); a.setAttribute('aria-hidden','false'); }
      else { a.hidden = true; a.setAttribute('hidden',''); a.setAttribute('aria-hidden','true'); }
    });
  };

  /* ---------- Article reading progress ---------- */
  (function(){
    var bar = qs('[data-gsh-read-progress]');
    var article = qs('.gsh-article__body');
    if (!bar || !article) return;
    var fill = bar.querySelector('span');
    function update(){
      var rect = article.getBoundingClientRect();
      var total = rect.height - window.innerHeight;
      var scrolled = -rect.top;
      var pct = total > 0 ? Math.min(100, Math.max(0, (scrolled / total) * 100)) : 0;
      fill.style.width = pct + '%';
    }
    window.addEventListener('scroll', update, {passive:true});
    window.addEventListener('resize', update, {passive:true});
    update();
  })();

  /* ---------- Print / save-as-PDF the return form (isolated) ---------- */
  document.addEventListener('click', function(e){
    var pf = e.target.closest('[data-gsh-print-form]');
    if (!pf) return;
    var doc = pf.closest('.gsh-legal__doc, .gsh-policy');
    var body = doc ? doc.querySelector('.gsh-legal__doc-body, .gsh-policy__body') : null;
    if (!body) return;
    var w = window.open('', '_blank', 'width=820,height=980');
    if (!w) { window.print(); return; }
    w.document.write('<!doctype html><html lang="sl"><head><meta charset="utf-8"><title>GlowSkinHouse — Obrazec za vračilo blaga</title><style>*{box-sizing:border-box}body{font-family:Georgia,\'Times New Roman\',serif;color:#17231e;max-width:720px;margin:22px auto;padding:0 26px;line-height:1.7;font-size:13.5px}h1{font-family:Georgia,serif;font-size:22px;font-weight:400;margin:0 0 6px}.gsh-print-brand{font-size:11px;letter-spacing:.2em;text-transform:uppercase;color:#9E6A45;margin-bottom:18px}strong{color:#000}a{color:#1c4a3c}p{margin:0 0 12px}ul,ol{padding-left:20px}@page{margin:16mm}</style></head><body><p class="gsh-print-brand">GlowSkinHouse</p><h1>Obrazec za vračilo blaga</h1>'+body.innerHTML+'</body></html>');
    w.document.close(); w.focus();
    setTimeout(function(){ try{ w.print(); }catch(err){} }, 350);
  });

  /* ---------- Legal / policies reader (tabs + mobile dropdown + hash) ---------- */
  (function(){
    var root = qs('[data-gsh-legal]');
    if (!root) return;
    var sel = root.querySelector('[data-legal-select]');
    function activate(id, doScroll){
      var found = false;
      Array.prototype.forEach.call(root.querySelectorAll('[data-legal-tab]'), function(t){ var m = t.getAttribute('data-legal-tab')===id; t.classList.toggle('is-active', m); if(m) found=true; });
      Array.prototype.forEach.call(root.querySelectorAll('[data-legal-doc]'), function(d){ d.classList.toggle('is-active', d.getAttribute('data-legal-doc')===id); });
      if (sel && found && sel.value!==id) sel.value = id;
      if (doScroll){ var c = root.querySelector('.gsh-legal__content'); if (c) c.scrollIntoView({behavior:'smooth', block:'start'}); }
      return found;
    }
    root.addEventListener('click', function(e){
      var tab = e.target.closest('[data-legal-tab]'); if (!tab) return;
      activate(tab.getAttribute('data-legal-tab'), window.innerWidth < 900);
    });
    if (sel) sel.addEventListener('change', function(){ activate(sel.value, true); });
    function fromHash(){
      var h = (window.location.hash || '').replace('#','');
      if (h && h.indexOf('legal-') === 0 && activate(h, false)){
        setTimeout(function(){ var s = qs('#pravno'); if (s) s.scrollIntoView({behavior:'smooth', block:'start'}); }, 80);
      }
    }
    fromHash();
    window.addEventListener('hashchange', fromHash);
  })();

  /* Vrnitev po vnosu kode v kosarici: odpri kosarico in pokazi, ali je koda uporabljena. */
  function promoMsg(text, ok){
    var m = qs('[data-gsh-promo-msg]'); if (!m) return;
    m.textContent = text; m.hidden = !text;
    m.classList.toggle('is-ok', !!ok); m.classList.toggle('is-err', !ok);
  }
  function promoApplied(cart, code){
    var c = String(code).toLowerCase();
    function hit(d){ return String(d && d.title || '').toLowerCase() === c; }
    return (cart.items || []).some(function(i){ return (i.discounts || []).some(hit); }) ||
           (cart.cart_level_discount_applications || []).some(hit);
  }
  function promoReturn(){
    var u; try { u = new URL(window.location.href); } catch (e) { return; }
    if (u.searchParams.get('gsh_cart') !== '1') return;
    var code = (u.searchParams.get('gsh_code') || '').trim();
    u.searchParams.delete('gsh_cart'); u.searchParams.delete('gsh_code');
    try { history.replaceState(null, '', u.pathname + u.search + u.hash); } catch (e) {}
    openDrawer(cartDrawer);
    if (!code) return;
    setTimeout(function(){
      fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
        var ok = promoApplied(cart, code);
        promoMsg(ok ? 'Koda ' + code.toUpperCase() + ' je uporabljena.'
                    : 'Koda ' + code.toUpperCase() + ' ni veljavna ali ne velja za izdelke v košarici.', ok);
      }).catch(function(){});
    }, 300);
  }

  document.addEventListener('DOMContentLoaded', function(){ renderCart(); promoReturn(); syncHearts(); updateWishCount(); syncCompareBtns(); renderCompareBar(); });
})();

/* ---------- Mobile-only accordions (footer columns + bundle routines) ---------- */
(function(){
  function isMobile(){ return window.matchMedia('(max-width:767px)').matches; }
  function init(){
    document.querySelectorAll('.gsh-footer__col-title').forEach(function(t){
      if(t.__gshAcc) return; t.__gshAcc=1;
      t.addEventListener('click', function(){ if(!isMobile()) return; var c=t.closest('.gsh-footer__col'); if(c) c.classList.toggle('is-open'); });
    });
    document.querySelectorAll('.gsh-routine__head').forEach(function(h){
      if(h.__gshAcc) return; h.__gshAcc=1;
      h.addEventListener('click', function(e){ if(!isMobile()) return; if(e.target.closest('a,button')) return; var r=h.closest('.gsh-routine'); if(r) r.classList.toggle('is-open'); });
    });
  }
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();

/* ---------- Mobile menu: re-parent out of the transform-trapping header group ---------- */
(function(){
  function fix(){ var m=document.querySelector('.gsh-mnav'); if(m && m.parentNode!==document.body) document.body.appendChild(m); }
  if(document.readyState!=='loading') fix(); else document.addEventListener('DOMContentLoaded', fix);
})();
